import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import {
  Alert as MuiAlert,
  Button,
  TextField as MuiTextField,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { spacing } from "@mui/system";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../redux/slices/snackbar";
import { API_BASE_URL } from "../../../config";

const Alert = styled(MuiAlert)(spacing);
const TextField = styled(MuiTextField)(spacing);

function ResetPasswordComponent() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const dispatchSnackbar = useDispatch();

  // Snackbar helper
  const handleSnackbar = (message, severity) => {
    dispatchSnackbar(showSnackbar({ message, severity }));
  };

  const handleEmailChange = (e) => setEmail(e.target.value);

  const handleSend = async () => {
    setSending(true);

    try {
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          data: {
            email: email,
          },
        }),
      };
      const response = await fetch(
        `${API_BASE_URL}/api/resetPassword`,
        options
      );
      const responseData = await response.json();
      if (responseData.status !== 1) {
        handleSnackbar(responseData.message, "error");
      } else {
        handleSnackbar(responseData.message, "success");
      }
      setSent(true);
      setSending(false);
    } catch (error) {
      console.error("Error during password reset:", error);
      return;
    }
  };

  const handleGoToLogin = () => navigate("/auth/sign-in");

  return (
    <Box>
      <Typography component="h1" variant="h4" align="center" gutterBottom>
        Resetta Password
      </Typography>
      {!sent ? (
        <Box>
          <Typography component="h2" variant="body1" align="center">
            Inserisci la tua email per ricevere le istruzioni per il reset della
            password.
          </Typography>
          <TextField
            type="email"
            name="email"
            label="Indirizzo Email"
            value={email}
            fullWidth
            onChange={handleEmailChange}
            my={3}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSend}
            disabled={sending || !email}
          >
            Invia Email
          </Button>
        </Box>
      ) : (
        <Box>
          {sending ? (
            <Box display="flex" justifyContent="center" my={4}>
              <CircularProgress />
            </Box>
          ) : (
            <Alert my={3}>
              Un'email è stata inviata all'indirizzo{" "}
              <span style={{ fontWeight: "bold" }}>{email}</span>, controlla la
              tua posta.
            </Alert>
          )}
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleGoToLogin}
          >
            Vai alla pagina di login
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default ResetPasswordComponent;
